import {AppConfigStore, HeaderStore, LoginStore} from '../../stores';

import { Link } from 'react-router-dom';
import Message from '../../components/message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import { connectToStores } from 'epic-alt-utils/index';
import { generateRoutePath } from '@epic-core/common';
import root from 'window-or-global';

@connectToStores
export default class DownloadView extends React.Component {
    static getStores() {
        return [LoginStore, AppConfigStore, HeaderStore];
    }

    static getPropsFromStores() {
        return {
            loginStore: LoginStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            headerStore: HeaderStore.getState()
        };
    }

    static propTypes = {
        loginStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        headerStore: PropTypes.object
    };

    componentDidMount = () => {
        const { loginStore, appConfigStore } = this.props;
        if (loginStore.isLoggedIn) return;
        root.location = `${appConfigStore.baseUrl}/login?&state=${root.document.URL}`;
    }

    render() {
        const { loginStore, headerStore, appConfigStore} = this.props;
        const {epicSid} = appConfigStore;
        const { macDownloadUrl, pcDownloadUrl } = headerStore.config;
        const pcUrl = `${pcDownloadUrl}?productName=unrealtournament&trackingId=${epicSid}`;
        const macUrl = `${macDownloadUrl}?productName=unrealtournament&trackingId=${epicSid}`
        if (!loginStore.isLoggedIn) return null;

        return (
            <div className="DownloadView">
                <div className="download-box">
                    <h3 className="download-title">
                        <Message code="epic.ut.download.thank_you" />
                    </h3>
                    <div className="download-epic-logo" />
                    <p className="download-for">
                        <Message code="epic.ut.download.download_for" />
                    </p>
                    <div className="download-links">
                        <a href={pcUrl} download><Message code="epic.ut.download.windows" /></a>
                        <a href={macUrl} download><Message code="epic.ut.download.mac" /></a>
                    </div>
                    <Link to={generateRoutePath().replace('home', '')} className="donwload-return-link">
                        <Message code="epic.ut.download.return" />
                    </Link>
                </div>
            </div>
        );
    }
}
